import { Component } from '@angular/core';
import { ResultQuoteWrapperComponent } from '@app/pages/quote/standard-quote/deals-standard-quote/result/result-wrapper.component';

@Component({
  selector: 'app-result-standard-desktop',
  templateUrl: './result-desktop.component.html',
  styleUrls: ['./result-desktop.component.scss'],
})
export class ResultDesktopComponent extends ResultQuoteWrapperComponent {

}
